import Component from '@galactic-advisors/component-loader';
import axios from 'axios';

const DEFAULTS = {
  evidenceDownloadButtonElement: '[data-evidence-download-button]',
  generateNewReportButtonElement: '[data-generate-new-report-button]',
  loaderElement: '[data-loader]',
  titleContainerElement: '[data-title-container]',
  titleMessage: '[data-title-message]',
  toastMessageContainerElement: '[data-toast-message-container]',
  toastMessageElement: '[data-toast-message]',
};

export default class GatherFullEvidence extends Component {
  static selector =
    '[data-comp-company-implementation-gather-full-evidence-modal]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.generateNewReportButton = this.$container.querySelector(
      this.$options.generateNewReportButtonElement
    );

    this.evidenceDownloadButton = this.$container.querySelector(
      this.$options.evidenceDownloadButtonElement
    );

    this.fetchRoute = this.generateNewReportButton.dataset.calculateRoute;

    this.fetchGenerationStatusRoute =
      this.$container.dataset.gatherFullEvidenceStatusRoute;

    this.loader = this.$container.querySelector(this.$options.loaderElement);

    this.titleMessage = this.$container.querySelector(
      this.$options.titleMessage
    );

    this.titleContainer = this.$container.querySelector(
      this.$options.titleContainerElement
    );

    this.toastMessageContainer = this.$container.querySelector(
      this.$options.toastMessageContainerElement
    );
    this.toastMessage = this.$container.querySelector(
      this.$options.toastMessageElement
    );

    this.initListeners();
    this.startStatusInterval();
  }

  dispatchGenerateEvidences() {
    const generationJobStatusId = axios({
      method: 'get',
      url: this.fetchRoute,
    }).catch((error) => {
      this.toastMessageContainer.classList.remove('d-none');
      this.toastMessage.innerText = error.response.data.message;
    });
    return generationJobStatusId;
  }

  getGenerationStatus(statusId) {
    const generationJobStatus = axios({
      method: 'post',
      data: { status_id: statusId },
      url: this.fetchGenerationStatusRoute,
    }).catch((error) => {
      this.toastMessageContainer.classList.remove('d-none');
      this.toastMessage.innerText = error.response.data.message;
    });

    return generationJobStatus;
  }

  showStatus(status) {
    if (status && status !== 'Finished') {
      this.toastMessageContainer.classList.remove('d-none');

      if (status === 'Failed') {
        this.toastMessage.innerText =
          'The last request for an evidence set failed to complete. ' +
          'This is normally due to missing implementation or scan report data. ' +
          'Please ensure the primary pentest exists for this company and ' +
          'implementations are properly filled and try again.';
        this.loader.classList.add('d-none');
        this.generateNewReportButton.classList.remove('d-none');
        this.generateNewReportButton.disabled = false;
        this.titleMessage && this.titleMessage.classList.add('d-none');
        return;
      }

      this.toastMessage.innerText = `Evidence set is being generated. Current status: ${status}`;
      this.generateNewReportButton.disabled = true;
      return;
    }

    this.titleContainer.classList.remove('d-none');
    this.toastMessageContainer.classList.add('d-none');
    this.loader.classList.add('d-none');
    this.evidenceDownloadButton &&
      this.evidenceDownloadButton.classList.remove('d-none');
    this.generateNewReportButton.classList.remove('d-none');
    this.generateNewReportButton.disabled = false;
  }

  updateStatuses() {
    this.getGenerationStatus().then((status) => {
      this.showStatus(status.data.data);
    });
  }

  dispatch() {
    this.dispatchGenerateEvidences().then(async (response) => {
      if (response.data.data) {
        const { statusId } = response.data.data;
        this.getGenerationStatus(statusId).then((status) => {
          this.showStatus(status.data.data);
        });
      } else {
        this.toastMessageContainer.classList.remove('d-none');
        this.toastMessage.innerText = response.data.message;
      }
    });
  }

  startStatusInterval() {
    const runStatusUpdateInterval = () => {
      this.updateStatuses();
      setTimeout(runStatusUpdateInterval, 5000);
    };

    runStatusUpdateInterval();
  }

  initListeners() {
    this.generateNewReportButton.addEventListener('click', async (event) => {
      event.preventDefault();
      this.evidenceDownloadButton &&
        this.evidenceDownloadButton.classList.add('d-none');
      this.toastMessageContainer.classList.add('d-none');
      this.generateNewReportButton.classList.add('d-none');
      this.titleContainer.classList.add('d-none');
      this.loader.classList.remove('d-none');
      this.dispatch();
    });
  }
}
